export default __webpack_public_path__ + "static/media/O_wdt_c_cap_0.34a762ac.mp3";